import { $, escHtml, _ensureMachineCache, _allMachinesCache } from './core';

/* ═══ CĂUTARE ÎN MANUALE (2026-07-26, INVENTAR_ACCES_DOCUMENTATIE faza 4)
   Poarta operatorului către cele ~21k pagini procesate: FTS exact (coduri
   de piesă/alarmă) + semantic (RAG), cu deschiderea PDF-ului la pagina
   exactă. Folosește /api/raw_text/search (include alias doc_parent_id). ═══ */

let manualsInited = false;

export async function initManuals(): Promise<void> {
    if (manualsInited) return;
    manualsInited = true;
    await _ensureMachineCache();
    const sel = $('#man-machine') as HTMLSelectElement | null;
    if (sel) {
        (_allMachinesCache || []).forEach((m: any) => {
            sel.innerHTML += `<option value="${escHtml(m.id)}">${escHtml(m.id)}${m.name ? ' — ' + escHtml(m.name) : ''}</option>`;
        });
    }
    document.getElementById('man-search-btn')?.addEventListener('click', () => { void runManualsSearch(); });
    ($('#man-q') as HTMLInputElement | null)?.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') { e.preventDefault(); void runManualsSearch(); }
    });
}

async function runManualsSearch(): Promise<void> {
    const qEl = $('#man-q') as HTMLInputElement | null;
    const out = document.getElementById('man-results');
    if (!qEl || !out) return;
    const q = qEl.value.trim();
    if (q.length < 2) {
        out.innerHTML = '<div class="dx-empty">Scrie cel puțin 2 caractere.</div>';
        return;
    }
    const machineId = ($('#man-machine') as HTMLSelectElement | null)?.value || '';
    const btn = document.getElementById('man-search-btn') as HTMLButtonElement | null;
    if (btn) { btn.disabled = true; btn.textContent = '⏳ Se caută...'; }
    out.innerHTML = '<div class="dx-empty">Se caută în manuale…</div>';
    try {
        const params = new URLSearchParams({ q, limit: '20' });
        if (machineId) params.set('machine_id', machineId);
        const res = await fetch(`/api/raw_text/search?${params.toString()}`);
        const data = await res.json();
        renderManualsResults(out, data, q);
    } catch (e) {
        out.innerHTML = '<div class="dx-empty" style="color:var(--danger)">Eroare la căutare — reîncearcă.</div>';
    } finally {
        if (btn) { btn.disabled = false; btn.textContent = '🔍 Caută'; }
    }
}

function renderManualsResults(out: HTMLElement, data: any, q: string): void {
    const rs = (data && data.results) || [];
    if (!rs.length) {
        /* „Nu s-a putut căuta" NU e același lucru cu „nu există în manual".
         * Până pe 19 sep 2026 amândouă ieșeau la fel: dacă serviciul semantic nu
         * răspundea, ecranul spunea «Niciun rezultat pentru „X"» — iar mecanicul
         * înțelegea că procedura nu e în manual și se oprea din căutat. Serverul
         * ne spune acum care din două e (`cautare_incompleta`). */
        if (data && data.cautare_incompleta) {
            out.innerHTML = `<div class="dx-empty" style="color:var(--warning,#b45309)">`
                + `Căutarea nu s-a putut face acum — serviciul de căutare în manuale `
                + `n-a răspuns. NU înseamnă că „${escHtml(q)}” lipsește din manual. `
                + `Încearcă din nou peste câteva secunde.</div>`;
            return;
        }
        out.innerHTML = `<div class="dx-empty">Niciun rezultat pentru „${escHtml(q)}”. Încearcă alt termen sau scoate filtrul de mașină.</div>`;
        return;
    }
    const badge = (t: string) => t === 'exact'
        ? '<span style="background:var(--green,#00c853);color:#fff;border-radius:4px;padding:1px 6px;font-size:.68rem;white-space:nowrap">potrivire exactă</span>'
        : '<span style="background:var(--accent,#2196f3);color:#fff;border-radius:4px;padding:1px 6px;font-size:.68rem;white-space:nowrap">semantic</span>';
    let html = `<div style="font-size:.78rem;color:var(--text-muted);margin-bottom:10px">${rs.length} rezultate`;
    if (data.doc_machine_ids && data.doc_machine_ids.length > 1) {
        html += ` — include documentația mașinii-mamă <strong>${escHtml(data.doc_machine_ids[1])}</strong>`;
    }
    html += '</div>';
    rs.forEach((r: any) => {
        // FTS marchează potrivirile cu ** — le facem <mark> DUPĂ escape
        let snip = escHtml(r.snippet || '');
        snip = snip.replace(/\*\*([^*]+)\*\*/g, '<mark>$1</mark>');
        html += `<div class="dx-card" style="padding:10px 14px;margin-bottom:8px">
            <div style="display:flex;justify-content:space-between;gap:8px;flex-wrap:wrap;align-items:center">
                <div style="font-weight:600;font-size:.85rem">${escHtml(r.filename || ('Document ' + r.document_id))} — pag. ${(r.page || 0) + 1} ${badge(r.match_type)}</div>
                <a class="btn btn-sm btn-outline" href="${escHtml(r.pdf_url || '#')}" target="_blank" rel="noopener">📄 Deschide PDF la pagină</a>
            </div>
            <div style="font-size:.72rem;color:var(--text-muted);margin:2px 0 6px">${escHtml(r.machine_id || '')}</div>
            <div style="font-size:.8rem;line-height:1.45">${snip}</div>
        </div>`;
    });
    out.innerHTML = html;
}
